import {
  View,
  Text,
  StyleSheet,
  Platform,
  TextInput,
  TouchableOpacity,
} from "react-native";
import React, { useEffect, useState, useRef } from "react";
import { white, textSecondary, primary } from "../../colors";
import MyText from "./MyText";
import { useSelector } from "react-redux";
import { Toast } from "react-native-toast-message/lib/src/Toast";

export default function MyInputWithLabel(props) {
  const main = useSelector((state) => state.main);

  const { value } = props;
  const textInput = useRef(null);
  const setColor = (text) => {
    props.setValue(text);
  };

  let persianNumber = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
  function correctNumber(text) {
    if (text === null || text === undefined) {
      return "";
    }
    if (!main.rtl) {
      if (text === null || text === undefined) {
        return "";
      }
      return text;
    }
    let chars = text?.split("");
    for (let i = 0; i < chars.length; i++) {
      if (/\d/.test(chars[i])) {
        chars[i] = persianNumber[chars[i]];
      }
    }
    return chars.join("");
  }
  const p2e = (s) =>
    s !== undefined ? s.replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d)) : "";

  const { Icon } = props;
  const direction =
    props.direction !== undefined ? props.direction : main.rtl ? "rtl" : "ltr";

  useEffect(() => {
    props.setInput((prev) => ({
      ...prev,
      [props.name]: value !== undefined ? value : null,
    }));
  }, [value]);

  return (
    <View style={[styles.container, props.style]}>
      <View style={styles.label}>
        <MyText
          style={[
            {
              fontSize: 16,
              color: "#999",
            },
            props.labelStyle,
          ]}
        >
          {props.text}
        </MyText>
      </View>
      <TouchableOpacity
        activeOpacity={1}
        onPress={() => {
          props.disabled ? null : textInput.current.focus();
        }}
      >
        <View
          style={{ ...styles.inputContainer, ...props.borderStyle }}
          pointerEvents="none"
        >
          <View style={Icon !== undefined ? styles.icon : null}>
            {Icon !== undefined ? (
              <Icon size={24} color={textSecondary} />
            ) : (
              <></>
            )}
          </View>
          <TextInput
            multiline={false}
            numberOfLines={1}
            maxLength={props.maxLength}
            keyboardType={props.keyboardType}
            secureTextEntry={props.star !== undefined}
            onChangeText={(text) => {
              props.setAnswer !== undefined ? props.setAnswer(text) : null;
              props.setInput((prev) => ({
                ...prev,
                [props.name]: p2e(text),
              }));
            }}
            ref={textInput}
            defaultValue={isNaN(value) ? value : value}
            style={[
              styles.textInput,
              {
                color: "#111",
                fontSize: 14,
                writingDirection: direction,
                textAlign: direction === "rtl" ? "right" : "left",
              },
              props.textInputStyle,
            ]}
            placeholderTextColor={textSecondary}
            placeholder={
              props.noPlaceHolder === undefined ? p2e(props.text) : ""
            }
          />
        </View>
      </TouchableOpacity>
    </View>
  );
}
const styles = StyleSheet.create({
  container: {
    width: "90%",
    marginBottom: 15,
  },
  label: {
    paddingHorizontal: 10,
    paddingVertical: 3,
  },
  inputContainer: {
    borderRadius: 13,

    borderColor: primary,
    borderWidth: 1,
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    height: 45,
    paddingLeft: 5,
    paddingRight: 5,
    backgroundColor: white,
  },
  icon: {
    width: 24,
    marginLeft: 5,
    marginRight: 5,
  },
  text: {
    color: textSecondary,
    fontSize: 18,
  },
  textInput: {
    fontFamily: "main",
    fontSize: 18,
    flex: 1,
    height: 30,
    outlineStyle: "none",
  },
});
